import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={29}
    height={29}
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={14.5} cy={14.5} r={14.5} fill="#4682B4" />
    <path
      d="M22 14.25C22.4142 14.25 22.75 14.5858 22.75 15C22.75 15.4142 22.4142 15.75 22 15.75V15V14.25ZM6.46967 15.5303C6.17678 15.2374 6.17678 14.7626 6.46967 14.4697L11.2426 9.6967C11.5355 9.40381 12.0104 9.40381 12.3033 9.6967C12.5962 9.98959 12.5962 10.4645 12.3033 10.7574L8.06066 15L12.3033 19.2426C12.5962 19.5355 12.5962 20.0104 12.3033 20.3033C12.0104 20.5962 11.5355 20.5962 11.2426 20.3033L6.46967 15.5303ZM22 15V15.75L7 15.75V15V14.25L22 14.25V15Z"
      fill="white"
    />
  </svg>
);

export default SVGComponent;
